import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./index";

const selectValidationState = (state) => state.validation || initialState;

export const triggerEmailValidation = createSelector(
  [selectValidationState],
  (validationState) => validationState.emailValidation
);
